/**
 * Change placement of some elements on the WooCommerce product page.
 */
(() => {
    const header = document.querySelector('h1.product_title');
    let gallery = document.querySelector(
        '.single-product .woocommerce-product-gallery'
    );

    if (!header || !gallery) {
        return;
    }

    header.classList.add('woocommerce__product_header');
    gallery.parentNode.insertBefore(header, gallery);

    const sale = document.querySelector('.product span.onsale');

    if (!sale) {
        return;
    }

    gallery.prepend(sale);
})();
